import { render, staticRenderFns } from "./MenuSelect.vue?vue&type=template&id=1361a9d0&"
import script from "./MenuSelect.vue?vue&type=script&lang=ts&"
export * from "./MenuSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports